export type ImageUploaderMode = 'profile' | 'direct';

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function resolveImageUploaderId(
    mode: ImageUploaderMode,
    imageId: unknown,
    dialogData: unknown
): string | null {
    if (typeof imageId === 'string' && GUID_PATTERN.test(imageId)) {
        return imageId;
    }

    if (mode === 'profile' && typeof dialogData === 'string' && GUID_PATTERN.test(dialogData)) {
        return dialogData;
    }

    return null;
}
